import React from 'react';
import { getStages } from '../config/verticals';

// Short title-case labels for the stepper dots, covering every stage id across
// all verticals (incl. the F3 business-plan stages). Distinct from App's
// STAGE_LABELS, which are lowercase phrases for the "welcome back" bubble.
const STEP_LABELS = {
  classify: 'Start',
  concept: 'Concept',
  // F5 upload-actuals stages (operating businesses only).
  actuals_upload: 'Upload',
  actuals_confirm: 'Review',
  loan_purpose: 'Loan Use',
  // Operating businesses only reach this stage for a capex-purpose loan —
  // the D2 schedule it feeds is titled Use of Funds, so the stepper matches.
  capital_expenses: 'Use of Funds',
  location: 'Location',
  revenue: 'Revenue',
  costs: 'Costs',
  cogs: 'COGS',
  opex: 'OpEx',
  capital: 'Capital',
  financing: 'Financing',
  ar_timing: 'AR Timing',
  growth: 'Growth',
  bp_collect: 'Plan Info',
  pfs_collect: 'Personal Financial Info',
  bp_generate: 'Plan Writing',
  bp_complete: 'Plan Done',
};

export default function StageProgress({ currentStage, vertical = 'restaurant', activeStages = null }) {
  // F5: prefer the session's active stage list (operating businesses get the
  // actuals/loan-purpose/capex stages inserted and `capital` dropped). Fall
  // back to the static vertical stages for pre-launch / first render. The
  // business-plan stages are appended either way so the stepper spans the
  // whole journey.
  const stages = activeStages && activeStages.length
    ? ['classify', ...activeStages, 'bp_collect', 'pfs_collect', 'bp_generate', 'bp_complete']
    : getStages(vertical);

  // `complete` is the transient financial-terminal stage; it isn't in the
  // stage list (the entry transition flips it to bp_collect). Treat it as
  // "all financial stages done, business plan not yet started" by anchoring
  // the marker just before bp_collect.
  let currentIdx = stages.indexOf(currentStage);
  if (currentIdx === -1 && currentStage === 'complete') {
    const bpStart = stages.indexOf('bp_collect');
    currentIdx = bpStart === -1 ? stages.length - 1 : bpStart - 1;
  }

  return (
    <div className="stage-progress">
      {stages.map((stageId, idx) => {
        let status = 'upcoming';
        if (idx < currentIdx) status = 'done';
        else if (idx === currentIdx) status = 'active';

        return (
          <div key={stageId} className={`stage-step ${status}`}>
            <div className="stage-dot" />
            <span className="stage-label">{STEP_LABELS[stageId] || stageId}</span>
          </div>
        );
      })}
    </div>
  );
}
